import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  Card,
  MissingWorkEntryComponent,
  RouterService,
  StateService,
} from 'projects/shared/src/public-api';
import { map, Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    public state: StateService,
    public routerService: RouterService,
    private modalCtrl: ModalController
  ) {}

  public subs: Subscription[] = [];

  ngOnInit(): void {
    this.state.init();
  }

  public openAbsenceEntries$ = this.state.absenceEntries$.pipe(
    map((x) => x?.filter((x) => !x.approvedBy).length)
  );

  public openAbsenceEntriesBadgeColor$ = this.openAbsenceEntries$.pipe(
    map((value) => {
      return this.getColor(value);
    })
  );

  public openReports$ = this.state.constructionDayReports$.pipe(
    map((x) => x?.filter((x) => !x.approvedBy).length)
  );

  public openReportsBadgeColor$ = this.openReports$.pipe(
    map((value) => {
      return this.getColor(value);
    })
  );

  public openInspections$ = this.state.inspections$.pipe(
    map((x) => x?.filter((x) => !x.approvedBy).length)
  );

  public openInspectionsBadgeColor$ = this.openInspections$.pipe(
    map((value) => {
      return this.getColor(value);
    })
  );

  public openMachines$ = this.state.machines$.pipe(
    map(
      (x) => x?.filter((x) => x.inspectionNecessary && !x.inspectionFree).length
    )
  );

  public openMachinesBadgeColor$ = this.openMachines$.pipe(
    map((value) => {
      return this.getColor(value);
    })
  );

  public missingWorkEntries$ = this.state.missingWorkEntries$.pipe(
    map((x) => x.length)
  );

  public missingWorkEntriesColor$ = this.missingWorkEntries$.pipe(
    map((value) => {
      return this.getColor(value);
    })
  );

  async openMissingWorkEntriesPopup() {
    const modal = await this.modalCtrl.create({
      component: MissingWorkEntryComponent,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }

  getColor(value: number): string {
    if (value === 0) return 'success';
    if (value < 5) return 'warning';
    if (value < 10) return 'danger';
    return 'danger';
  }

  ngOnDestroy(): void {
    this.subs?.forEach((x) => x.unsubscribe());
  }
}
